import type { OnboardingSyncWindowDays } from '@/types/historical-sync';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface ILookupOption {
  key: string;
  label: string;
  placeholder: string;
  value: boolean;
}

export interface IWelcomeState {
  step: number;
  lookupOptions: ILookupOption[];
  isDoneSyncOrders: boolean;
  onboardRequired: string[];
  planRequired: string[];
  selectedSyncWindow: OnboardingSyncWindowDays;
}

const initialState: IWelcomeState = {
  step: 1,
  lookupOptions: [],
  isDoneSyncOrders: false,
  onboardRequired: [],
  planRequired: [],
  selectedSyncWindow: 7,
};

export const welcomeSlice = createSlice({
  name: 'welcome',
  initialState,
  reducers: {
    handleChangeStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    handleChangeLookupOption: (state, action: PayloadAction<ILookupOption[]>) => {
      state.lookupOptions = action.payload;
    },
    handleDoneSyncOrders: (state) => {
      state.isDoneSyncOrders = true;
    },
    setSelectedSyncWindow: (state, action: PayloadAction<OnboardingSyncWindowDays>) => {
      state.selectedSyncWindow = action.payload;
    },
  },
});

export const {
  handleChangeStep,
  handleChangeLookupOption,
  handleDoneSyncOrders,
  setSelectedSyncWindow,
} = welcomeSlice.actions;

export const stepSelector = (state: RootState) => state.welcome.step;
export const lookupOptionsSelector = (state: RootState) => state.welcome.lookupOptions;
export const isDoneSyncOrdersSelector = (state: RootState) => state.welcome.isDoneSyncOrders;
export const selectedSyncWindowSelector = (state: RootState) => state.welcome.selectedSyncWindow;
export default welcomeSlice.reducer;
